import React from 'react';
import { Slider, Radio, Tooltip, InputNumber, Menu, Dropdown, Button, Input } from 'antd';
import PropertyGridUtils from '../PropertyGridUtils';
import PropertyEditor from "../PropertyEditor";

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

export default class OffsetEditor extends PropertyEditor {

    state = {
    };

    constructor(props, context) {
        super(props, context);
    }

    componentWillMount() {
        super.componentWillMount();

        const v = this.props.source.value;
        if (!v)
            this.props.source.value = { x: 0, y: 0 };
    }

    onXChange(e) {
        this.props.source.value = {
            x: e,
            y: this.props.source.value.y,
        };
        this.setState({});
    }

    onYChange(e) {
        this.props.source.value = {
            x: this.props.source.value.x,
            y: e,
        };
        this.setState({});
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {
        this.setState({});
    }

    render() {

        let value = this.props.source.value;
        if (!value)
            return;

        return (
            <div className="property-editor--offset">
                <div className="layout-h center hstretch">
                    <div className="label label-h">横: </div>
                    <InputNumber
                        className="fill"
                        value={value.x}
                        min={this.props.source.minValue === undefined ? Number.MIN_SAFE_INTEGER : this.props.source.minValue}
                        max={this.props.source.maxValue === undefined ? Number.MAX_SAFE_INTEGER : this.props.source.maxValue}
                        onChange={e => this.onXChange(e)} />

                    <div className="label label-v">纵: </div>
                    <InputNumber
                        className="fill"
                        value={value.y}
                        min={this.props.source.minValue === undefined ? Number.MIN_SAFE_INTEGER : this.props.source.minValue}
                        max={this.props.source.maxValue === undefined ? Number.MAX_SAFE_INTEGER : this.props.source.maxValue}
                        onChange={e => this.onYChange(e)} />
                </div>
            </div>
        );
    }
}

PropertyGridUtils.register("offset", (source, propertyGrid) => <OffsetEditor source={source} propertyGrid={propertyGrid} />);